import { createFileRoute, Navigate } from '@tanstack/react-router'
import { navPath } from '@bloo-team/core-shell'
import { identityFor, useSession } from '../../../lib/session'
import { visibleGroups } from '@bloo-team/core-shell'

/**
 * /settings has no page of its own: the gear lands on the first section this
 * identity may see, the way a settings area is expected to open. The nav
 * beside it is the table of contents, so a landing page would only repeat it.
 * An identity that may see nothing gets a one-line say-so instead of a loop.
 */
function SettingsIndex() {
  const { clusterId, scopeId } = Route.useParams()
  const session = useSession()
  const identity = session ? identityFor(session, clusterId, scopeId) : null
  const first = visibleGroups(identity)[0]?.items[0]
  const target = first ? (first.children?.[0] ?? first) : null
  if (!target) {
    return (
      <div className="app-stack app-stack-wide">
        <section className="hud-panel sy-card" aria-label="Settings">
          <span className="hud-eyebrow">Nothing to configure</span>
          <p className="sy-help">Your role reaches no Settings section on this deployment.</p>
        </section>
      </div>
    )
  }
  return <Navigate to={navPath(clusterId, scopeId, target.to)} replace />
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/')({
  component: SettingsIndex,
})
